module.exports = __webpack_public_path__ + "img/logo.40a85e67.png";